export default function groupBySession(takeAways) {
  const sessions = []
  const groupBy = (xs, key) => {
    return xs.reduce((rv, x) => {
      ;(rv[x[key]] = rv[x[key]] || []).push(x)
      return rv
    }, {})
  }

  const renderableTakeAways = takeAways.filter((takeAway) => {
    return takeAway?.thumbnailUrl || takeAway?.memoryArtifactId || takeAway?.url
  })

  const sessionGroups = groupBy(renderableTakeAways, 'userSessionId')

  Object.values(sessionGroups).forEach((session) => {
    sessions.push(session)
  })

  return sessions
}
